<template>
  <crud-card title="Dados Financeiros">
    <v-container fluid>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-row>
          <v-col cols="auto">
            <v-autocomplete
              v-model="banco"
              :items="bancos"
              item-text="nome"
              item-value="id"
              :rules="[rules.required]"
              rounded
              dense
              outlined
              label="Banco"
              clearable
              :filter="filterBancos"
            >
              <template
                slot="item"
                slot-scope="data"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ data.item.descricao }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ data.item.codigo + ' - ' + data.item.nome }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="auto">
            <v-text-field
              v-model="agencia"
              dense
              :rules="agenciaRules"
              rounded
              outlined
              label="Agência"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-text-field
              v-model="conta"
              dense
              :rules="contaRules"
              rounded
              outlined
              label="Conta"
              clearable
            />
          </v-col>
          <v-col cols="auto">
            <v-btn
              class="text-none"
              rounded
              dark
              color="primary"
              @click="addContaClear()"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
              Adicionar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container
      fluid
    >
      <v-data-table
        :items="contas"
        :headers="headers"
        item-key="id"
      >
        <template v-slot:[`item.status`]="{ item, index }">
          <v-simple-checkbox
            v-model="item.status"
            color="success"
            @click="ativarConta(index)"
          />
        </template>
        <template v-slot:[`item.actions`]="{ item, index }">
          <v-icon
            color="error"
            style="cursor: pointer;"
            @click="removeConta(index)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:[`item.banco`]="{ item }">
          {{ returnNameBanco(item.banco) }}
        </template>
        <template v-slot:[`item.agencia`]="{ item }">
          {{ item.agencia }}
        </template>
        <template v-slot:[`item.conta`]="{ item }">
          {{ item.conta }}
        </template>
      </v-data-table>
    </v-container>
  </crud-card>
</template>
<script>
  import { mapMultiRowFields } from 'vuex-map-fields'
  import rules from '../../utils/formRules'

  import api from '@/api/api'
  import { v4 } from 'uuid'

  export default {
    name: 'ProdutorBanco',
    props: {
      removeConta: {
        type: Function,
        default: (index) => {
          this.contas.splice(index, 1)
        },
      },
      addConta: {
        type: Function,
        default: (conta) => {
          this.contas.push(conta)
        },
      },
      ativarConta: {
        type: Function,
        default: (index) => {
          this.contas.forEach((element, i) => {
            if (i === index) {
              element.status = true
              return
            }
            element.status = false
          })
        },
      },
    },
    data () {
      return {
        valid: true,
        rules: rules,
        bancos: [],
        optional: [],
        banco: null,
        agencia: '',
        conta: '',
        contaRules: [
          v => !!v || 'O número da conta é obrigatório',
          v => (v && v.length <= 12) || 'O número da conta maior que 12 digitos',
          v => /^[0-9\-.]*$/.test(v) || 'O número da conta invalido',
        ],
        agenciaRules: [
          v => !!v || 'O número da agencia é obrigatório',
          v => (v && v.length <= 6) || 'O número da agencia maior que 6 digitos',
          v => /^[0-9\-.]*$/.test(v) || 'O número da agencia invalido',
        ],
        api,
        headers: [
          { text: '', value: 'actions', sortable: false, width: '60px' },
          { text: 'Status', value: 'status', sortable: false, width: '60px' },
          { text: 'Banco', value: 'banco' },
          { text: 'Agência', value: 'agencia' },
          { text: 'Conta', value: 'conta' },
        ],
      }
    },

    computed: {
      ...mapMultiRowFields('form', [
        'data.contas',
      ]),
    },

    async created () {
      this.bancos = await this.api.listEntidade('bancos')
    },

    methods: {
      addContaClear () {
        if (!this.$refs.form.validate()) {
          return
        }
        this.addConta({
          id: v4(),
          status: false,
          banco: this.banco,
          agencia: this.agencia,
          conta: this.conta,
        })
        this.banco = null
        this.agencia = ''
        this.conta = ''

        this.$refs.form.resetValidation()
      },

      returnNameBanco (id) {
        const banco = this.bancos.find(banco => banco.id === id)
        return banco ? banco.nome : ''
      },

      filterBancos (item, queryText, itemText) {
        if (item.codigo.includes(queryText)) return true
        if (item.nome.toLowerCase().includes(queryText.toLowerCase())) return true
        if (item.descricao.toLowerCase().includes(queryText.toLowerCase())) return true
        return false
      },

    },
  }
</script>
